import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=3645e490&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645e490",
  null
  
)

export default component.exports